import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAdminSellerEdit = () => {
  const [loading, setLoading] = useState(true);
  const [csrf, setCsrf] = useState('');
  const [error, setError] = useState('');
  const [seller, setSeller] = useState(null);

  const [username, setUsername] = useState('');
  const [shopName, setShopName] = useState('');
  const [password, setPassword] = useState('');

  const params = new URLSearchParams(window.location.search);
  const sellerId = params.get('id') || '';

  useEffect(() => {
    fetchData();
  }, [window.location.search]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `/api/platform_admin/seller_edit?id=${encodeURIComponent(sellerId)}`,
        { withCredentials: true }
      );

      if (res.data && res.data.ok) {
        const row = res.data.seller || null;
        setCsrf(res.data.csrf || '');
        setError(res.data.error || '');
        setSeller(row);

        if (row) {
          setUsername(row.username || '');
          setShopName(row.shop_name || '');
          setPassword('');
        }
      } else if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      if (err.response && err.response.data && err.response.data.msg) {
        alert(err.response.data.msg);
        if (err.response.status === 400 || err.response.status === 404) {
          window.location.href = '/platform_admin/sellers';
          return;
        }
      }

      console.error('셀러 수정 화면 로드 실패:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }

      window.location.href = '/platform_admin/login';
    } catch (err) {
      console.error('로그아웃 실패:', err);
      window.location.href = '/platform_admin/login';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new URLSearchParams();
      formData.append('csrf_token', csrf);
      formData.append('username', username);
      formData.append('shop_name', shopName);
      formData.append('password', password);

      const res = await axios.post(
        `/api/platform_admin/seller_edit?id=${encodeURIComponent(sellerId)}`,
        formData,
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        }
      );

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      if (err.response && err.response.data) {
        if (typeof err.response.data.error !== 'undefined') {
          setError(err.response.data.error || '');
        }
        if (err.response.data.msg) {
          alert(err.response.data.msg);
        }
        return;
      }

      console.error('셀러 수정 실패:', err);
      setError('수정 중 오류가 발생했습니다.');
    }
  };

  return (
    <div className="bg-light min-vh-100">
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand">플랫폼 관리자</span>
        <div>
          <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light me-2">
            셀러관리
          </a>
          <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light me-2">
            상점관리
          </a>
          <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light me-2">
            주문관리
          </a>
          <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light me-2">
            클레임
          </a>
          <a href="/platform_admin/notices" className="btn btn-sm btn-outline-light me-2">
            공지관리
          </a>
          <a href="/platform_admin/logout" onClick={handleLogout} className="btn btn-sm btn-danger">
            로그아웃
          </a>
        </div>
      </nav>

      <div className="container my-4">
        <h4 className="mb-3">✏️ 셀러 정보 수정</h4>

        {error ? <div className="alert alert-danger">{error}</div> : null}

        <div className="card shadow-sm">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-4 text-muted">불러오는 중...</div>
            ) : !seller ? (
              <div className="text-center py-4 text-muted">셀러가 존재하지 않습니다.</div>
            ) : (
              <form onSubmit={handleSubmit}>
                <input type="hidden" name="csrf_token" value={csrf} />

                <div className="mb-3">
                  <label className="form-label">사용자명 (username)</label>
                  <input
                    type="text"
                    name="username"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">상점명</label>
                  <input
                    type="text"
                    name="shop_name"
                    className="form-control"
                    value={shopName}
                    onChange={(e) => setShopName(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">비밀번호 (변경 시에만 입력)</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    placeholder="비워두면 기존 비밀번호 유지"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

                <div className="d-flex justify-content-end gap-2">
                  <a href="/platform_admin/sellers" className="btn btn-secondary">
                    취소
                  </a>
                  <button type="submit" className="btn btn-success">
                    저장
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAdminSellerEdit;